import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import localStorage from '../Common/LocalStorage';
import { UserRoleValue, UserRole } from '../Common/UserRole';
import Svgs from '../Common/Svgs';
import {
    FormRow,
    Input,
    AddRoleSelect,
    AddCompanyAdminSelect,
    AddCompanyOwnerSelect,
    AddCompanyManagerSelect,
    AddPharmacyAdminSelect,
    AddPharmacyOwnerSelect,
    AddPharmacyManagerSelect,
    MainBtn,
    CancelBtn
} from '../Common/form/Elements-export';
import { createUser } from './epics-users';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
import { StaticRoutePaths } from '../Common/ClientRoutes';
import { getRoleHandler } from '../Common/Helpers';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class AddUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: false,
            username: '',
            email: '',
            phone: '',
            role: '',
            company: '',
            pharmacy: '',
            validation: {
                username: '',
                email: '',
                phone: '',
                role: '',
                company: '',
                pharmacy: ''
            },
            validationCounter: 0,
            validatedForm: false,
            changedRoleOfUser: false
        };
    }

    update = (type, property) => e => {
        if (property === 'roleSelect' && localStorage.getUsernameRole() === UserRole.ADMIN) {
            this.setState({
                ...this.state,
                [type]: e.target.value,
                company: '',
                pharmacy: ''
            });
        } else {
            this.setState({ ...this.state, [type]: e.target.value });
        }
    };

    isFieldsValidated = (type, typeValue) => {
        if (typeValue.length === 0) {
            if (this.state.validation[type] === '') {
                this.setState(prevState => ({
                    ...this.state,
                    validation: {
                        ...this.state.validation,
                        [type]: strings.not_empty_error
                    },
                    validationCounter: prevState.validationCounter + 1
                }));
            }
        } else {
            if (this.state.validationCounter === 0) {
                this.setState(prevState => ({
                    ...this.state,
                    validation: {
                        ...this.state.validation,
                        [type]: ''
                    },
                    validationCounter: prevState.validationCounter + 0
                }));
            } else {
                this.setState(prevState => ({
                    ...this.state,
                    validation: {
                        ...this.state.validation,
                        [type]: ''
                    },
                    validationCounter: prevState.validationCounter - 1
                }));
            }
        }

        this.isFormValidated();
    };

    isFormValidated = () => {
        if (this.state.validationCounter !== 0) {
            this.setState({
                validatedForm: false
            });
        } else {
            this.setState({
                validatedForm: true
            });
        }
    };

    createUserHandler = () => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });

        createUser(this.state)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                this.props.history.push(StaticRoutePaths.USERS);
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        username:
                            this.generateErrorMessage(error.body, 'names')
                                .join(' ')
                                .trim() || '',
                        email:
                            this.generateErrorMessage(error.body, 'email')
                                .join(' ')
                                .trim() || '',
                        phone:
                            this.generateErrorMessage(error.body, 'phone')
                                .join(' ')
                                .trim() || '',
                        role:
                            this.generateErrorMessage(error.body, 'roles')
                                .join(' ')
                                .trim() || '',
                        pharmacy:
                            this.generateErrorMessage(error.body, 'pharmacy')
                                .join(' ')
                                .trim() || ''
                    }
                });
            });
    };

    generateErrorMessage = (errArray, errName) => {
        if (errArray !== null) {
            return (errArray || []).map(singleErr => {
                return singleErr.property_path === errName ? singleErr.message : '';
            });
        }
    };

    showErrors = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    cancelUserHandler = () => {
        this.props.history.push(StaticRoutePaths.USERS);
    };

    getCompanyIdHandler = () =>  (this.props.companyList.length !== 0 ? this.props.companyList[0].id : '');

    getCompanyNameHandler = () => (this.props.companyList.length !== 0 ? this.props.companyList[0].name : 'No company');

    getPharmacyIdHandler = () => (this.props.pharmacyList.length !== 0 ? this.props.pharmacyList[0].id : '');

    getPharmacyNameHandler = () => (this.props.pharmacyList.length !== 0 ? this.props.pharmacyList[0].name : 'No pharmacy');

    componentDidMount() {
        if (this.props.status === UserRole.STORE_OWNER) {
            this.setState({
                ...this.state,
                company: this.getCompanyIdHandler()
            });
        }
        if (this.props.status === UserRole.PHARMACY_MANAGER) {
            this.setState({
                ...this.state,
                role: UserRoleValue.PHARMACIST,
                company: this.getCompanyIdHandler(),
                pharmacy: this.getPharmacyIdHandler()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.role !== prevState.role) {
            this.props.update('companyList', getRoleHandler(this.state.role));
            this.props.update('pharmacyList', this.state.company, getRoleHandler(this.state.role));
        }
        if (this.state.company !== prevState.company) {
            this.props.update('pharmacyList', this.state.company, getRoleHandler(this.state.role));
        }
    }

    generateCompanySelect = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                return (
                    <AddCompanyAdminSelect
                        {...this.props}
                        role={this.state.role}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        selectname="select_name"
                        placeholder={strings.select_company}
                        extraClasses="col-4"
                    />
                );
            case UserRole.STORE_OWNER:
                return (
                    <AddCompanyOwnerSelect
                        {...this.props}
                        role={this.state.role}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        selectname="select_name"
                        placeholder={this.getCompanyNameHandler()}
                        extraClasses="col-4"
                    />
                );
            case UserRole.PHARMACY_MANAGER:
                return (
                    <AddCompanyManagerSelect
                        {...this.props}
                        role={this.state.role}
                        type="company"
                        handler={this.update('company')}
                        label={`* ${strings.Company}`}
                        selectname="select_name"
                        placeholder={this.getCompanyNameHandler()}
                        extraClasses="col-4"
                    />
                );
            default:
                return;
        }
    };

    generatePharmacySelect = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                return (
                    <AddPharmacyAdminSelect
                        {...this.props}
                        role={this.state.role}
                        type="pharmacy"
                        handler={this.update('pharmacy')}
                        label={`* ${strings.Pharmacy}`}
                        selectname="select_name"
                        placeholder={strings.Select_pharmacy}
                        extraClasses="col-4"
                    />
                );
            case UserRole.STORE_OWNER:
                return (
                    <AddPharmacyOwnerSelect
                        {...this.props}
                        type="pharmacy"
                        handler={this.update('pharmacy')}
                        label={`* ${strings.Pharmacy}`}
                        selectname="select_name"
                        placeholder={strings.Select_pharmacy}
                        extraClasses="col-4"
                    />
                );
            case UserRole.PHARMACY_MANAGER:
                return (
                    <AddPharmacyManagerSelect
                        {...this.props}
                        type="pharmacy"
                        handler={this.update('pharmacy')}
                        label={`* ${strings.Pharmacy}`}
                        selectname="select_name"
                        placeholder={this.getPharmacyNameHandler()}
                        extraClasses="col-4"
                    />
                );
            default:
                return;
        }
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.users}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title text-capitalize">
                                    <i className="fa fa-plus-square mr-2" />
                                    {strings.Add_new_user}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.USERS} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <FormRow>
                            <Input
                                handler={this.update('username')}
                                label={`* ${strings.Name}`}
                                placeholder={strings.User_Full_name}
                                extraClasses="col-8"
                                value={this.state.username}
                            />
                            <AddRoleSelect
                                {...this.props}
                                type="role"
                                handler={this.update('role', 'roleSelect')}
                                label={`* ${strings.Role}`}
                                selectname="select_name"
                                placeholder={strings.role_select_placeholder}
                                extraClasses="col-4"
                            />
                            <div className="col-8">{this.showErrors(this.state.validation.username)}</div>
                            <div className="col-4"> {this.showErrors(this.state.validation.role)}</div>
                        </FormRow>

                        <FormRow>
                            <Input
                                handler={this.update('email')}
                                label={`* ${strings.Email}`}
                                placeholder={strings.user_email_placeholder}
                                extraClasses="col-8"
                                value={this.state.email}
                            />
                            {this.generateCompanySelect(localStorage.getFromStorage('role'))}
                            <div className="col-8">{this.showErrors(this.state.validation.email)}</div>
                            <div className="col-4"> {this.showErrors(this.state.validation.company)}</div>
                        </FormRow>
                        <FormRow>
                            <Input
                                handler={this.update('phone')}
                                label={`* ${strings.phone}`}
                                placeholder={strings.work_phone}
                                extraClasses="col-8"
                                value={this.state.phone}
                            />
                            {this.generatePharmacySelect(localStorage.getFromStorage('role'))}
                            <div className="col-8">{this.showErrors(this.state.validation.phone)}</div>
                            <div className="col-4"> {this.showErrors(this.state.validation.pharmacy)}</div>
                        </FormRow>

                        <FormRow>
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3" />
                                ) : (
                                    <CancelBtn
                                        onclick={this.cancelUserHandler}
                                        title={strings.cancel}
                                        extraClasses="qf-gray-btn w-100 mt-4"
                                    />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="col-11 white-bg px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={this.createUserHandler}
                                        title={strings.Add_user}
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </FormRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AddUser);



// WEBPACK FOOTER //
// ./src/customModules/Users/component-add-user.js